export const SUITS = [
  { id: 'hearts',   label: 'Harten',   symbol: '♥', red: true,  order: 0 },
  { id: 'diamonds', label: 'Ruiten',   symbol: '♦', red: true,  order: 1 },
  { id: 'clubs',    label: 'Klaveren', symbol: '♣', red: false, order: 2 },
  { id: 'spades',   label: 'Schoppen', symbol: '♠', red: false, order: 3 },
]
